

import ContactForm from './ContactForm';

const ContactFormContainer = () => {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-border max-w-md mx-auto">
      <div className="p-8 bg-card">
        <ContactForm />
      </div>
    </div>
  );
};

export default ContactFormContainer;
